import { inject, Injectable } from '@angular/core';
import { MaritalStatus } from '@app/shared/interfaces/common-data/marital-status';
import { catchError, Observable, of } from 'rxjs';
import { PERSONAL_DATA_BASE_PATH } from '@app/shared/constants/communications';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfigService as appConfig } from '@app/app.config';
import { Profession } from '@app/shared/interfaces/common-data/profession';
import { ProfessionalSector } from '../../interfaces/common-data/professional-sector';
import { HouseType } from '@app/shared/interfaces/common-data/house-type';

@Injectable({
    providedIn: 'root',
})
export class PersonalDataService {
    private http = inject(HttpClient);
    private appConfig = inject(appConfig);

    /**
     * Returns a list of all marital status from CommonsBusiness:AddresData API.
     */
    getMaritalStatus(): Observable<MaritalStatus[]> {
        const MARITALSTATUS_URL: string = this.appConfig.apiBffUrl + PERSONAL_DATA_BASE_PATH + '/marital-status';
        return this.http.get<MaritalStatus[]>(MARITALSTATUS_URL).pipe(catchError(() => of([])));
    }

    /**
     * Returns a list of all professions from CommonsBusiness:AddresData API.
     */
    getProfessions(filters: { sectorCode?: string; professionCode?: string; fieldCode?: string } = {}): Observable<Profession[]> {
        const { sectorCode, professionCode, fieldCode } = filters;
        const PROFESSIONS_URL: string = this.appConfig.apiBffUrl + PERSONAL_DATA_BASE_PATH + '/professions';
        let params = new HttpParams();
        params = sectorCode ? params.append('sectorCode', sectorCode) : params;
        params = professionCode ? params.append('professionCode', professionCode) : params;
        params = fieldCode ? params.append('fieldCode', fieldCode) : params;
        return this.http.get<Profession[]>(PROFESSIONS_URL, { params: params }).pipe(catchError(() => of([])));
    }

    /**
     * Returns a list of all professional sectors from CommonsBusiness:AddresData API.
     */
    getProfessionalSectors(): Observable<ProfessionalSector[]> {
        const PROFESSIONALSECTORS_URL: string = this.appConfig.apiBffUrl + PERSONAL_DATA_BASE_PATH + '/professions/sectors';
        return this.http.get<ProfessionalSector[]>(PROFESSIONALSECTORS_URL).pipe(catchError(() => of([])));
    }

    getHouseTypes(): Observable<HouseType[]> {
        const HOUSETYPE_URL: string = this.appConfig.apiBffUrl + PERSONAL_DATA_BASE_PATH + '/housing-types';
        return this.http.get<HouseType[]>(HOUSETYPE_URL).pipe(catchError(() => of([])));
    }
}
